import { createSelector } from 'reselect';
import { scheduleTimeSelector } from 'selectors/scheduleTimeSelector';
import { getTime } from 'utils/timeHelpers';

export const getDeliveryTime = createSelector(
  scheduleTimeSelector,
  scheduleTime => getTime(scheduleTime),
);
